const state = {
  codigo: null,
  title: null,
  modalVideo: false,
}
const mutations = {
  abreVideo: (state, opts) => {
    state.codigo = opts.codigo
    state.title = opts.title
    state.modalVideo = true
  },
  fechaVideo: (state) => {
    state.codigo = null
    state.title = null
    state.modalVideo = false
  }
}
export default {
  namespaced: true,
  root: true,
  state,
  mutations
}
